import { useState } from "react";
import ConfirmModal from "./ConfirmModal";
import { deleteDeliveryLocation } from "../../utils/zulalWebAPI";
import toast from "react-hot-toast";

const AddressCard1 = ({ address, onEdit, refreshList, totalLocations }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedLocationId, setSelectedLocationId] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  // Called when "Remove" is clicked
  const confirmDelete = (locationId) => {
    setSelectedLocationId(locationId);
    setIsModalOpen(true);
  };

  // Function to remove the delivery location
  const handleDelete = async () => {
    // Restrict deletion if total locations are 1
    if (totalLocations === 1) {
      toast.error("You cannot delete the last address");
      setIsModalOpen(false);
      return;
    }

    setIsDeleting(true);

    try {
      // console.log("Deleting location with ID:", selectedLocationId);

      // ✅ Send locationId directly without encryption
      const response = await deleteDeliveryLocation(selectedLocationId);
      // console.log("Delete response:", response);

      if (response.status === "success") {
        toast.success("Address deleted successfully");
        setIsModalOpen(false);
        await refreshList(); // Trigger re-fetching of addresses
      } else {
        toast.error(response.message || "Error deleting address");
      }
    } catch (error) {
      console.error("Error in handleDelete:", error);
      toast.error("Failed to delete address");
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div className="border border-secondary rounded-md shadow-lg p-4 bg-primaryVeryLight">
      <div className="text-sm text-gray-500 mb-2">
        <div className="flex items-start gap-x-3">
          {address.isDefault && (
            <p className="mt-0.5 rounded-full bg-green-100 px-1.5 py-0.5 text-C11 font-semibold whitespace-nowrap text-green-700 ring-1 ring-green-600/20 ring-inset">
              Default
            </p>
          )}
          <p className="text-sm/6 font-semibold text-gray-900 uppercase">
            {address.locationLabel}
          </p>
        </div>
      </div>
      <div>
        <hr className="mb-1" />
      </div>
      <div className="text-sm text-gray-800 leading-6">
        <p className="font-poppins text-base">{address.RecipientName}</p>
        <p>
          {address.flatNumber}, {address.buildingName},{" "}
          {`${address.areaName}(${address.areaCode})`},<p>{address.Landmark}</p>
          {`${address.statessName}(${address.stateCode})`}, <br />
        </p>
        <p className="font-poppins text-C12">Contact: {address.phoneNumber}</p>
      </div>
      <div className="mt-4 text-sm text-blue-600 space-x-2">
        <button
          onClick={() => onEdit(address)}
          className="mt-2 bg-yellow-500 text-white px-3 py-1 rounded hover:bg-yellow-600 transition"
        >
          Edit
        </button>
        <span>|</span>
        <button
          className="hover:underline"
          onClick={() => confirmDelete(address.locationId)}
          disabled={isDeleting}
        >
          {isDeleting ? "Removing..." : "Remove"}
        </button>
      </div>
      <ConfirmModal
        isOpen={isModalOpen}
        onConfirm={handleDelete}
        onCancel={() => {
          setIsModalOpen(false);
          setSelectedLocationId(null);
        }}
        message="Do you want to delete this address?"
        isLoading={isDeleting}
      />
    </div>
  );
};

export default AddressCard1;
